<template>
  <NuxtLink :to="`/news/${news.id}`" class="news-item">
    <div class="date-label">
      <span class="news-date">{{ formatDate(news.displayDate, 'YYYY.MM.DD') }}</span>
      <PartsNewsLabel :category="news.newsCategory" />
    </div>
    <span class="news-title">{{ news.title }}</span>
  </NuxtLink>
</template>

<script setup lang="ts">
/**
 * 支給デザインの `news-item`。トップの「お知らせ」と `/news` 一覧で同じものを使う。
 *
 * 日付とラベルのラッパは `date-label` にする。支給はトップが `date-label`
 * （`design-src/20260810/index.html:472`）、お知らせ一覧が `date-label-wrapper`
 * （`news/index.html:435`）で揺れているが、`renewal/style.css:1324`（`.news-list .date-label`）と
 * `renewal/guide.css:116`（`.date-label-wrapper`）は同じ内容なので見た目は変わらない。
 * **`.news-list` の中に置くことが前提**（`.date-label` 側は子孫セレクタのため）。
 */
import type { NewsType } from '@/types/domains/index';
import { formatDate } from '@/utils/DateHelper';

type Props = {
  news: NewsType.News;
};
defineProps<Props>();
</script>
